// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Layout Flex Item Component */
:host([align-self=auto]),
.ids-layout-flex-item-align-self-auto {
  align-self: auto;
}

:host([align-self=baseline]),
.ids-layout-flex-item-align-self-baseline {
  align-self: baseline;
}

:host([align-self=center]),
.ids-layout-flex-item-align-self-center {
  align-self: center;
}

:host([align-self=stretch]),
.ids-layout-flex-item-align-self-stretch {
  align-self: stretch;
}

:host([align-self=flex-start]),
.ids-layout-flex-item-align-self-flex-start {
  align-self: flex-start;
}

:host([align-self=flex-end]),
.ids-layout-flex-item-align-self-flex-end {
  align-self: flex-end;
}

:host([grow="0"]),
.ids-layout-flex-item-grow-0 {
  flex-grow: 0;
}

:host([grow="1"]),
.ids-layout-flex-item-grow-1 {
  flex-grow: 1;
}

:host([shrink="0"]),
.ids-layout-flex-item-shrink-0 {
  flex-shrink: 0;
}

:host([shrink="1"]),
.ids-layout-flex-item-shrink-1 {
  flex-shrink: 1;
}

:host([overflow=auto]),
.ids-layout-flex-item-overflow-auto {
  overflow: auto;
}

:host([overflow=hidden]),
.ids-layout-flex-item-overflow-hidden {
  overflow: hidden;
}

:host([overflow=visible]),
.ids-layout-flex-item-overflow-visible {
  overflow: visible;
}

:host([overflow=scroll]),
.ids-layout-flex-item-overflow-scroll {
  overflow: scroll;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-layout-flex/ids-layout-flex-item.scss"],"names":[],"mappings":"AAAA,mCAAA;AAME;;EAEE,gBALc;AAClB;;AAEE;;EAEE,oBALc;AAMlB;;AAHE;;EAEE,kBALc;AAWlB;;AARE;;EAEE,mBALc;AAgBlB;;AAbE;;EAEE,sBALc;AAqBlB;;AAlBE;;EAEE,oBALc;AA0BlB;;AAbE;;EAEE,YALa;AAqBjB;;AAlBE;;EAEE,YALa;AA0BjB;;AAbE;;EAEE,cALe;AAqBnB;;AAlBE;;EAEE,cALe;AA0BnB;;AAbE;;EAEE,cALY;AAqBhB;;AAlBE;;EAEE,gBALY;AA0BhB;;AAvBE;;EAEE,iBALY;AA+BhB;;AA5BE;;EAEE,gBALY;AAoChB","sourcesContent":["/* Ids Layout Flex Item Component */\n\n// Align-self\n$align-self-list: auto baseline center stretch flex-start flex-end;\n\n@each $align-self in $align-self-list {\n  :host([align-self='#{$align-self}']),\n  .ids-layout-flex-item-align-self-#{$align-self} {\n    align-self: $align-self;\n  }\n}\n\n// Flex-grow\n$flex-grow-list: 0 1;\n\n@each $flex-grow in $flex-grow-list {\n  :host([grow='#{$flex-grow}']),\n  .ids-layout-flex-item-grow-#{$flex-grow} {\n    flex-grow: $flex-grow;\n  }\n}\n\n// Flex-shrink\n$flex-shrink-list: 0 1;\n\n@each $flex-shrink in $flex-shrink-list {\n  :host([shrink='#{$flex-shrink}']),\n  .ids-layout-flex-item-shrink-#{$flex-shrink} {\n    flex-shrink: $flex-shrink;\n  }\n}\n\n// Overflow\n$overflow-list: auto hidden visible scroll;\n\n@each $overflow in $overflow-list {\n  :host([overflow='#{$overflow}']),\n  .ids-layout-flex-item-overflow-#{$overflow} {\n    overflow: $overflow;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
